import { render, staticRenderFns } from "./PaceOfPlay.vue?vue&type=template&id=61f48a57&"
import script from "./PaceOfPlay.vue?vue&type=script&lang=js&"
export * from "./PaceOfPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports